import { isRoot } from "./helpers";

export interface DigitalSignatureMayInterface {
  (session: SessionInterface, path: "digital-signatures"): boolean;
  (session: SessionInterface, path: "digital-signatures", action: "new"): boolean;
  (
    session: SessionInterface,
    path: "digital-signatures",
    action: "delete" | "edit" | "show",
    envelope: DigitalSignatureEnvelope,
  ): boolean;

  (
    session: SessionInterface,
    path: "digital-signatures",
    action: "send",
    envelope: DigitalSignatureEnvelopeDetail,
  ): boolean;
}

const DigitalSignaturesPermissions: PermissionType<DigitalSignatureEnvelopeDetail> = {
  "digital-signatures": {
    index: ({ currentUser }) => isRoot(currentUser),
    edit: ({ currentUser }, resource) => resource.status !== "SIGNED" && isRoot(currentUser),
    send: ({ currentUser }, resource) =>
      resource.status === "NEW" && resource.fields.length > 0 && resource.files.length > 0 && isRoot(currentUser),
  },
};

export default DigitalSignaturesPermissions;
